var offsetTopStatusBar = 0;
const emailInput = document.querySelector('#order-email');
const orderNumberInput = document.querySelector('#order-number');
const submitButton = document.querySelector('#tpt-order-tracking-submit-button');
const elementStatusbar = document.querySelector('.tpt-order-tracker__box.tpt-order-tracker__order-status');

/**
 * Validate form
 */
function validateForm() {
	const email = emailInput.value.trim();
	const orderId = orderNumberInput.value.trim();

	submitButton.disabled = !(email && orderId);
}

/**
 * Close note
 */
document.addEventListener('click', (event) => {
	const closeButton = event.target.closest('.tpt-order__note-close');
	if (!closeButton) return;

	const parentNote = closeButton.closest('.tpt-order__note, .tpt-order__note-refund');
	if (!parentNote) return;

	parentNote.classList.add('tpt-order__note--hidden');
});

/**
 * Scroll to order box
 */

const statusItems = document.querySelectorAll('.tpt-order-tracker__order-status-item');
const mainOrderStatus = document.querySelectorAll('.tpt-order-tracker__box-status');

statusItems.forEach((statusItem) => {
	statusItem.addEventListener('click', (event) => {
		const target = statusItem.getAttribute('data-target');
		const tagetElement = document.getElementById(target);

		statusItems.forEach((item) => {
			item.classList.remove('active');
		});

		mainOrderStatus.forEach((item) => {
			item.classList.remove('active');
		});

		statusItem.classList.add('active');
		tagetElement.classList.add('active');

		const offset = 120;
		const top = tagetElement.getBoundingClientRect().top + window.scrollY - offset;

		window.scrollTo({
			top,
			behavior: 'smooth',
		});
	});
});

/**
 * Format money
 */

function tptFormatMoney(moneyObject) {
	var re = new RegExp(String.fromCharCode(160), 'g');
	return parseFloat(moneyObject.amount)
		.toLocaleString('th-TH', {
			style: 'currency',
			currency: moneyObject.currencyCode,
		})
		.replace(re, '');
}

/**
 * Order loaded
 */
function orderLoaded() {
	document.querySelector('.tpt-order-tracker').classList.add('tpt-order-tracker--loaded');
}

/**
 * Back to form order tracker
 */
function backToOrderTracker() {
	window.history.replaceState({}, '', window.location.pathname);
	document.querySelector('.tpt-order-tracker').classList.remove('tpt-order-tracker--loaded');
}

/**
 * Collapsed no items
 */

function collapsedBox(boxSelector) {
	boxSelector.querySelector('.tpt-order__collapse-heading input[type="checkbox"]').checked = false;
}

function collapseAllStatusBoxesExceptCanceled() {
	const boxes = document.querySelectorAll('.tpt-order-tracker__box-status');

	boxes.forEach((box) => {
		if (!box.classList.contains('tpt-order-tracker__box-canceled')) {
			collapsedBox(box);
		}
	});
}

/**
 * Auto active first package has item
 */

function autoActiveFirstPackageHasItem() {
	const firstPackageWithItem = document.querySelector('.tpt-order-tracker__order-status-item.tpt-order-tracker__has-package');

	if (firstPackageWithItem) {
		firstPackageWithItem.click();
	}
}

/**
 * Error modal
 */

function showErrorModal() {
	document.querySelector('.tpt-order-tracker__error').classList.add('active');
}

/**
 * Close modal error
 */

document.addEventListener('click', (event) => {
	const errorElement = document.querySelector('.tpt-order-tracker__error');

	if (!errorElement) return;

	if (event.target.classList.contains('tpt-order-tracker__error')) {
		errorElement.classList.remove('active');
	}

	if (event.target.closest('.tpt-order-tracker__error-close')) {
		errorElement.classList.remove('active');
	}
});

/**
 * Back to form
 */
document.querySelector('.tpt-order-tracker__back')?.addEventListener('click', () => {
	backToOrderTracker();
});

/**
 * Show refund label process
 * activeLabel: process / completed
 */

function showRefundLabel(container, activeLabel) {
	const refundLabelElements = container.querySelectorAll('.tpt-refund__label');

	if (!refundLabelElements.length) return;

	refundLabelElements.forEach((refundLabelElement) => {
		// Reset class trạng thái cũ
		refundLabelElement.classList.remove('active-label-process', 'active-label-completed');

		// Active
		refundLabelElement.classList.add('active');

		if (activeLabel === 'process') {
			refundLabelElement.classList.add('active-label-process');
		} else {
			refundLabelElement.classList.add('active-label-completed');
		}
	});
}

/**
 * Submit form
 */
async function tptGetOrderDetails() {
	const order_email = emailInput.value.trim();
	const order_id = orderNumberInput.value.trim();

	if (!order_email || !order_id) return;

	try {
		submitButton.disabled = true;

		const response = await fetch('https://ssp-trackernsync.pwa-commerce.com/api/tltrackorder', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				order_id,
				order_email,
			}),
		});

		const text = await response.text();

		if (!text) return null;

		const data = JSON.parse(text);

		if (data?.order?.id) {
			const pushUrlPath = window.location.pathname + '?order_id=' + encodeURIComponent(order_id) + '&order_email=' + encodeURIComponent(order_email);

			window.history.pushState({}, '', pushUrlPath);
		}

		const order = data.order;

		if (order.id && order.email) {
			renderOrderDetail(order);
			orderLoaded();
		} else {
			showErrorModal();
		}

		return data;
	} catch (error) {
		console.error(error);
		return null;
	} finally {
		validateForm();
	}
}

emailInput.addEventListener('input', validateForm);
orderNumberInput.addEventListener('input', validateForm);

submitButton.addEventListener('click', tptGetOrderDetails);

validateForm();

/**
 * Auto submit from URL params
 */

const params = new URLSearchParams(window.location.search);

const orderIdParam = params.get('order_id');
const orderEmailParam = params.get('order_email');

if (orderIdParam && orderEmailParam) {
	orderNumberInput.value = orderIdParam;
	emailInput.value = orderEmailParam;

	validateForm();

	tptGetOrderDetails();
}

/**
 * Check order type: Home delivery or Pickup in store
 * Check Order.shipping_lines.title Contains: Shipping, Standard, Free Shipping => Home delivery
 */

function checkDelivery(order) {
	const shippingTitle = order?.shippingLine?.title || '';

	const isHomeDelivery = shippingTitle.includes('Shipping') || shippingTitle.includes('Standard') || shippingTitle.includes('Free Shipping');

	return isHomeDelivery ? 'home-delivery' : 'pickup-in-store';
}

function renderOrderDetail(order) {
	const orderTrackerContainer = document.querySelector('.tpt-order-tracker__order-detail');
	const deliveryType = checkDelivery(order);

	/* Sidebar */
	renderOrderInfo(order);

	/* Main */
	if (deliveryType === 'home-delivery') {
		orderTrackerContainer.classList.remove('tpt-order-tracker__order-detail--store-pickup');
		orderTrackerContainer.classList.add('tpt-order-tracker__order-detail--home-delivery');
		renderOrderMainHomeDelivery(order);
	} else {
		orderTrackerContainer.classList.remove('tpt-order-tracker__order-detail--home-delivery');
		orderTrackerContainer.classList.add('tpt-order-tracker__order-detail--store-pickup');
		renderOrderMainPickupInStore(order);
	}

	/**
	 * Init sticky status bar
	 */
	setTimeout(() => {
		offsetTopStatusBar = elementStatusbar.getBoundingClientRect().top + window.scrollY;

		window.addEventListener('scroll', () => {
			if (window.scrollY >= offsetTopStatusBar) {
				elementStatusbar.classList.add('tpt-order-tracker__order-status--sticky');
			} else {
				elementStatusbar.classList.remove('tpt-order-tracker__order-status--sticky');
			}
		});

		autoActiveFirstPackageHasItem();
	}, 100);
}

/**
 * Get Order Detail (data from sidebar)
 */

function getOrderInfo(order) {
	if (!order) return null;

	const deliveryType = checkDelivery(order);

	return {
		orderId: order.name,
		confirmedDate: new Date(order.createdAt).toLocaleDateString('en-GB'),
		//totalItem: order.lineItems?.nodes?.length || 0,
		totalItem: order?.lineItems?.nodes?.reduce((total, item) => total + (item.quantity || 0), 0) || 0,
		//paid: tptFormatMoney(order.currentSubtotalPriceSet?.presentmentMoney),
		paid: tptFormatMoney(order.subtotalPriceSet?.shopMoney),
		shipping: tptFormatMoney(order.totalShippingPriceSet?.presentmentMoney),
		payment: order.paymentGatewayNames?.[0] || '',
		deliveryType,
		deliveryValue: deliveryType === 'home-delivery' ? 'Home Delivery' : 'Pickup in store',
	};
}

/**
 * Render order info
 */

function renderOrderInfo(order) {
	const orderInfo = getOrderInfo(order);

	if (!orderInfo) return;

	const elements = {
		'tpt-order__order-id': orderInfo.orderId,
		'tpt-order__date-confirm': orderInfo.confirmedDate,
		// 'tpt-order__count-number': orderInfo.totalItem,
		'tpt-order__detail-paid': orderInfo.paid,
		'tpt-order__detail-shipping': orderInfo.shipping,
		'tpt-order__detail-date': orderInfo.confirmedDate,
		//'tpt-order__detail-payment': orderInfo.payment,
		'tpt-order__detail-payment': orderInfo.payment === '2C2P' ? window.tptTrackOrder.tctp : orderInfo.payment,
		'tpt-order__detail-delivery': orderInfo.deliveryValue,
		'tpt-order__customer-name': [order.shippingAddress?.firstName, order.shippingAddress?.lastName].filter(Boolean).join(' '),
		'tpt-order__customer-address': [order.shippingAddress?.address1, order.shippingAddress?.address2, order.shippingAddress?.city].filter(Boolean).join(', '),
		'tpt-order__customer-phone': order.shippingAddress?.phone || '',
	};

	Object.entries(elements).forEach(([id, value]) => {
		const el = document.getElementById(id);

		if (el) {
			el.innerHTML = value;
		}
	});
}

/**
 * Render Main Data
 */

function financialStatus(order) {
	return order.displayFinancialStatus;
}

function countTotalPackage() {
	const badges = document.querySelectorAll('.tpt-order-tracker__order-status-list .tpt-order-tracker__order-status-badges');
	const countElement = document.getElementById('tpt-order__count-number');

	const total = [...badges].reduce((sum, badge) => {
		return sum + (parseInt(badge.textContent.trim(), 10) || 0);
	}, 0);

	if (countElement) {
		countElement.textContent = total;
	}
}

/**
 * Main Home Delivery
 */
function renderOrderMainHomeDelivery(order) {
	const financialStatusValue = financialStatus(order);

	if (financialStatusValue === 'VOIDED') {
		renderHomeDeliveryVoidedCanceled(order);
		collapseAllStatusBoxesExceptCanceled();
	} else {
		if (order.cancelledAt) {
			renderHomeDeliveryCanceled(order);
			collapseAllStatusBoxesExceptCanceled();
		} else {
			renderHomeDeliveryConfirmed(order);
			renderHomeDeliveryPartialCanceled(order);
			renderHomeDeliveryReturns(order);
			renderHomeDeliveryPacked(order);
			renderHomeDeliveryDelivered(order);
			renderHomeDeliveryShipping(order);
			renderHomeDeliveryFailedDelivery(order);
		}
	}

	countTotalPackage();
}

/**
 * Main Pickup in Store
 */
function renderOrderMainPickupInStore(order) {
	const financialStatusValue = financialStatus(order);

	if (financialStatusValue === 'VOIDED') {
		renderPickupCanceled(order);
		collapseAllStatusBoxesExceptCanceled();
	} else {
		if (order.cancelledAt) {
			renderPickupCanceled(order);
			collapseAllStatusBoxesExceptCanceled();
		} else {
			renderPickupConfirmed(order);
			renderPickupReadyToCollect(order);
			renderPickupCollected(order);
			renderPickupPartialCanceled(order);
			renderPickupReturns(order);
			renderPickupRefunded(order);
		}
	}

	countTotalPackage();
}

function renderProduct(products = []) {
	return products
		.map((product) =>
			PRODUCT_HTML.replace(
				'__PRODUCT_IMAGE__',
				`<img
					src="${product.image}"
					alt="${product.title}"
				/>`,
			)
				.replace('__PRODUCT__TITLE__', product.title)
				.replace('__PRODUCT__VARIANT__', product.variantTitle)
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.quantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');
}

/**
 * Count product item
 */
function countProductItem(elements, countValue) {
	document.querySelectorAll(elements).forEach((el) => {
		el.innerHTML = countValue;
	});

	if (countValue > 0) {
		document.querySelector(`.tpt-order-tracker__order-status ${elements}`).closest('.tpt-order-tracker__order-status-item').classList.add('tpt-order-tracker__has-package');
	}
}

function containsPackage(element, text, countValue) {
	document.querySelector(element).innerHTML = text.replace('__COUNT_ITEM__', countValue);
}

/**
 * Render html product home delivery return
 * transaction != SUCCESS
 */

function getNotDeliveredReturnProducts(order, returnItems) {
	const fulfillments = order?.fulfillments?.filter((fulfillment) => fulfillment?.displayStatus === 'NOT_DELIVERED') || [];

	const groupedProducts = {};

	console.log('fulfillments: ',fulfillments);

	fulfillments.forEach((fulfillment) => {
		const fulfillmentLineItems = fulfillment?.fulfillmentLineItems?.nodes || [];

		fulfillmentLineItems.forEach((fulfillmentItem) => {
			const lineItem = fulfillmentItem?.lineItem;

			if (!lineItem?.id) return;

			// Match với returnLineItems
			const matchedReturnItem = returnItems.find((item) => item.lineItemId === lineItem.id);

			if (!matchedReturnItem) return;

			const returnName = matchedReturnItem.returnName || '-';

			if (!groupedProducts[returnName]) {
				groupedProducts[returnName] = {
					returnName,
					returnedAt: matchedReturnItem.returnedAt || '',
					products: [],
				};
			}

			groupedProducts[returnName].products.push({
				trackingNumber: fulfillment?.trackingInfo?.[0]?.number || '-',
				id: lineItem.id || '',
				title: lineItem.title || '',
				variantTitle: lineItem.variantTitle || '',
				image: lineItem.image?.url || '',
				sku: lineItem.sku || '',
				quantity: fulfillmentItem?.quantity || 0,
				refundableQuantity: matchedReturnItem?.returnLineItem?.refundableQuantity || 0,
				discountedTotalSet: fulfillmentItem?.discountedUnitPriceAfterAllDiscountsSet || lineItem?.discountedUnitPriceAfterAllDiscountsSet || null,
			});
		});
	});

	console.log('Not Delivered Grouped Products:', groupedProducts);

	var groupReturnHtml = '';
	const payment = order.paymentGatewayNames?.[0] || '';

	if (payment === 'Cash on Delivery') {
		groupReturnHtml = PRODUCT_HTML_RETURN_NOTE_NO_REFUND_LABEL_GROUP;
	} else {
		groupReturnHtml = PRODUCT_HTML_RETURN_NOTE_REFUND_LABEL_GROUP;
	}

	// Tạo HTML riêng cho NOT_DELIVERED
	var html = Object.values(groupedProducts)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_RETURN.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}">` : '')
						.replace('__PRODUCT_TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : ''))
						.replace('__PRODUCT_VARIANT__', product.variantTitle || '')
						.replace(
							'__PRODUCT_PRICE__',
							(() => {
								const lineItem = order?.lineItems?.nodes?.find(
									(item) => item?.id === product?.id,
								);

								const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
								const quantity = Number(product?.quantity) || 0;

								return money?.amount
									? tptFormatMoney({
											amount: Number(money.amount) * quantity,
											currencyCode: money.currencyCode,
										})
									: '';
							})(),
						),
				)
				.join('');

			return groupReturnHtml
				.replace('__RETURN_NAME__', group.returnName || '-')
				.replace('__RETURN_DATE__', group.returnedAt || '')
				.replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	// Check payment
	const returnStatus = order?.returns?.nodes?.[0]?.status || '';
	const returnNote = document.getElementById('tpt-order__note-content');

	if (payment === 'Cash on Delivery') {
		if (returnStatus === 'CLOSED') {
			html = html.replaceAll('__PROCESS_DOTS__', returnProcessOne);
			returnNote.innerHTML = window.tptTrackOrder.returnedNoteTwo;
		} else {
			html = html.replaceAll('__PROCESS_DOTS__', returnProcessOne);
			//html = html.replaceAll('__PROCESS_DOTS__', returnProcessSix);
			returnNote.innerHTML = window.tptTrackOrder.returnedNoteOne;
		}
	} else {
		if (order?.refunds?.length || order?.tags?.includes('refunded_status')) {
			html = html.replaceAll('__PROCESS_DOTS__', returnProcessTwo);
			returnNote.innerHTML = window.tptTrackOrder.returnedNoteFour;
		} else {
			html = html.replaceAll('__PROCESS_DOTS__', returnProcessThree);
			returnNote.innerHTML = window.tptTrackOrder.returnedNoteThree;
		}
	}

	return {
		html,
		products: Object.values(groupedProducts).flatMap((group) => group.products),
	};
}

function getDeliveredReturnProducts(order, returnItems) {
	const fulfillments = order?.fulfillments?.filter((fulfillment) => fulfillment?.displayStatus === 'DELIVERED') || [];

	console.log('Delivered Fulfillments:', fulfillments);

	const groupedProducts = {};

	fulfillments.forEach((fulfillment) => {
		const fulfillmentLineItems = fulfillment?.fulfillmentLineItems?.nodes || [];

		fulfillmentLineItems.forEach((fulfillmentItem) => {
			const lineItem = fulfillmentItem?.lineItem;

			if (!lineItem?.id) return;

			// Match với returnLineItems
			const matchedReturnItem = returnItems.find((item) => item.lineItemId === lineItem.id);

			if (!matchedReturnItem) return;

			const returnName = matchedReturnItem.returnName || '-';

			if (!groupedProducts[returnName]) {
				groupedProducts[returnName] = {
					returnName,
					returnedAt: matchedReturnItem.returnedAt || '',
					products: [],
				};
			}

			groupedProducts[returnName].products.push({
				trackingNumber: fulfillment?.trackingInfo?.[0]?.number || '-',

				id: lineItem.id || '',
				title: lineItem.title || '',
				variantTitle: lineItem.variantTitle || '',
				image: lineItem.image?.url || '',
				sku: lineItem.sku || '',

				quantity: fulfillmentItem?.quantity || 0,

				refundableQuantity: matchedReturnItem?.returnLineItem?.refundableQuantity || 0,

				discountedTotalSet: fulfillmentItem?.discountedUnitPriceAfterAllDiscountsSet || lineItem?.discountedUnitPriceAfterAllDiscountsSet || null,
			});
		});
	});

	console.log('Delivered Grouped Products:', groupedProducts);

	// Tạo HTML riêng cho DELIVERED
	var html = Object.values(groupedProducts)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_RETURN.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}">` : '')
						.replace('__PRODUCT_TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : ''))
						.replace('__PRODUCT_VARIANT__', product.variantTitle || '')
						.replace(
							'__PRODUCT_PRICE__',
							(() => {
								const lineItem = order?.lineItems?.nodes?.find(
									(item) => item?.id === product?.id,
								);

								const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
								const quantity = Number(product?.quantity) || 0;

								return money?.amount
									? tptFormatMoney({
											amount: Number(money.amount) * quantity,
											currencyCode: money.currencyCode,
										})
									: '';
							})(),
						),
				)
				.join('');

			return PRODUCT_HTML_RETURN_NOTE_REFUND_LABEL_GROUP.replace('__RETURN_NAME__', group.returnName || '-')
				.replace('__RETURN_DATE__', group.returnedAt || '')
				.replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	console.log('Delivered Return Products HTML:', html);

	if (order?.refunds?.length || order?.tags?.includes('refunded_status')) {
		html = html.replaceAll('__PROCESS_DOTS__', returnProcessFive);
	} else {
		html = html.replaceAll('__PROCESS_DOTS__', returnProcessFour);
	}

	return {
		html,
		products: Object.values(groupedProducts).flatMap((group) => group.products),
	};
}

function renderHomeDeliveryReturns(order) {
	const container = document.getElementById('tpt-order-tracker__products-returned--wrapper');

	if (!container) return;

	/*
	 * ---------------------------------------------------------
	 * 1. Lấy returnLineItems để dùng làm dữ liệu đối chiếu
	 * ---------------------------------------------------------
	 */
	const returnItems =
		order?.returns?.nodes?.flatMap((returnItem) =>
			(returnItem?.returnLineItems?.nodes || [])
				.map((item) => {
					const lineItem = item?.fulfillmentLineItem?.lineItem;

					if (!lineItem?.id) return null;

					return {
						returnName: returnItem?.name || '-',

						returnedAt: returnItem?.requestApprovedAt ? new Date(returnItem.requestApprovedAt).toLocaleDateString('en-GB') : '',

						lineItemId: lineItem.id,

						returnLineItem: item,
					};
				})
				.filter(Boolean),
		) || [];

	/*
	 * ---------------------------------------------------------
	 * 2. Lấy HTML từ NOT_DELIVERED
	 * ---------------------------------------------------------
	 */
	const notDeliveredResult = getNotDeliveredReturnProducts(order, returnItems);

	/*
	 * ---------------------------------------------------------
	 * 3. Lấy HTML từ DELIVERED
	 * ---------------------------------------------------------
	 */
	const deliveredResult = getDeliveredReturnProducts(order, returnItems);

	/*
	 * ---------------------------------------------------------
	 * 4. Append HTML từ 2 function
	 * ---------------------------------------------------------
	 */
	container.innerHTML = notDeliveredResult.html + deliveredResult.html;

	/*
	 * ---------------------------------------------------------
	 * 5. Tổng số sản phẩm
	 * ---------------------------------------------------------
	 */
	const returnedItems = [...notDeliveredResult.products, ...deliveredResult.products];

	const totalReturnedItems = returnedItems.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__return', totalReturnedItems);

	containsPackage('.tpt-order-returned__subheading', window.tptTrackOrder.containsPackage, totalReturnedItems);

	/*
	 * ---------------------------------------------------------
	 * 6. Refund status
	 * ---------------------------------------------------------
	 */
	if (order?.refunds?.length || order?.tags?.includes('refunded_status')) {
		showRefundLabel(container, 'completed');
	} else {
		showRefundLabel(container, 'process');
	}

	/*
	 * ---------------------------------------------------------
	 * 7. Không có sản phẩm
	 * ---------------------------------------------------------
	 */
	if (returnedItems.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * Render html product homve delivery delivered
 */

function renderHomeDeliveryDeliveredBackup(order) {
	const container = document.getElementById('tpt-order-tracker__products-delivered--wrapper');

	if (!container) return null;

	// Lấy tất cả lineItem.id đã return
	const returnedLineItemIds = new Set(order?.returns?.nodes?.flatMap((returnItem) => returnItem?.returnLineItems?.nodes?.map((item) => item?.fulfillmentLineItem?.lineItem?.id) || []) || []);

	const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'DELIVERED') || [];

	const deliveredProducts = fulfillments.flatMap(
		(fulfillment) =>
			fulfillment.fulfillmentLineItems?.nodes
				?.map((item) => {
					const lineItem = item?.lineItem || {};

					// Skip product đã return
					if (returnedLineItemIds.has(lineItem.id)) {
						return null;
					}

					return {
						packageName: fulfillment.name,
						trackingNumber: fulfillment.trackingInfo?.[0]?.number || '',
						fulfilledAt: fulfillment.deliveredAt ? new Date(fulfillment.deliveredAt).toLocaleDateString('en-GB') : '',
						id: lineItem.id || '',
						title: lineItem.title || '',
						variantTitle: lineItem.variantTitle || '',
						image: lineItem.image?.url || '',
						sku: lineItem.sku || '',
						quantity: lineItem.quantity || 0,
						discountedTotalSet: lineItem.discountedUnitPriceAfterAllDiscountsSet || null,
					};
				})
				.filter(Boolean) || [],
	);

	container.innerHTML = deliveredProducts
		.map((product) =>
			PRODUCT_HTML_DELIVERED.replace('__PACKED_TRACKING_NUMBER__', product.trackingNumber)
				.replace('__DELIVERED_DATE__', product.fulfilledAt)
				.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}" />` : '')
				.replace('__PRODUCT__TITLE__', product.title + ` X ${product.quantity}`)
				.replace('__PRODUCT__VARIANT__', product.variantTitle)
				.replace(
					'__PRODUCT_PRICE__',
					(() => {
						const lineItem = order?.lineItems?.nodes?.find(
							(item) => item?.id === product?.id,
						);

						const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
						const quantity = Number(product?.quantity) || 0;

						return money?.amount
							? tptFormatMoney({
									amount: Number(money.amount) * quantity,
									currencyCode: money.currencyCode,
								})
							: '';
					})(),
				),
		)
		.join('');

	countProductItem('.tpt-order-count__delivered', deliveredProducts.length);
	containsPackage('.tpt-order-delivered__subheading', window.tptTrackOrder.containsPackage, deliveredProducts.length);

	if (deliveredProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

function renderHomeDeliveryDelivered(order) {
	const container = document.getElementById('tpt-order-tracker__products-delivered--wrapper');

	if (!container) return null;

	// Lấy tất cả lineItem.id đã return
	const returnedLineItemIds = new Set(order?.returns?.nodes?.flatMap((returnItem) => returnItem?.returnLineItems?.nodes?.map((item) => item?.fulfillmentLineItem?.lineItem?.id) || []) || []);

	const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'DELIVERED') || [];

	const deliveredProducts = fulfillments.flatMap(
		(fulfillment) =>
			fulfillment.fulfillmentLineItems?.nodes
				?.map((item) => {
					const lineItem = item?.lineItem || {};

					// Skip product đã return
					if (returnedLineItemIds.has(lineItem.id)) {
						return null;
					}

					return {
						package: fulfillment.name || '',
						trackingNumber: fulfillment.trackingInfo?.[0]?.number || '',
						fulfilledAt: fulfillment.deliveredAt ? new Date(fulfillment.deliveredAt).toLocaleDateString('en-GB') : '',
						id: lineItem.id || '',
						title: lineItem.title || '',
						variantTitle: lineItem.variantTitle || '',
						image: lineItem.image?.url || '',
						sku: lineItem.sku || '',
						quantity: item?.quantity || 0,
						discountedTotalSet: lineItem.discountedUnitPriceAfterAllDiscountsSet || null,
					};
				})
				.filter(Boolean) || [],
	);

	// Group products theo tracking number
	// Group products theo package (18/06)
	const groupedProducts = deliveredProducts.reduce((groups, product) => {
		const key = product.package || '';

		if (!groups[key]) {
			groups[key] = {
				trackingNumber: product.trackingNumber,
				fulfilledAt: product.fulfilledAt,
				products: [],
			};
		}

		groups[key].products.push(product);

		return groups;
	}, {});

	console.log('TEST....', groupedProducts);

	const html = Object.values(groupedProducts)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_DELIVERED.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}">` : '')
						.replace('__PRODUCT__TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : '') || '')
						.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
						.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.quantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
				)
				.join('');

			return PRODUCT_HTML_DELIVERED_GROUP.replace('__PACKED_TRACKING_NUMBER__', group.trackingNumber || '')
				.replace('__PACKED_DATE__', group.fulfilledAt || '')
				.replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	container.innerHTML = html;

	const totalDeliveredItems = deliveredProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__delivered', totalDeliveredItems);

	containsPackage('.tpt-order-delivered__subheading', window.tptTrackOrder.containsPackage, totalDeliveredItems);

	if (deliveredProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

function renderHomeDeliveryPacked(order) {
	const container = document.getElementById('tpt-order-tracker__products-packed--wrapper');

	if (!container) return;

	// Không hiển thị Packed nếu order đã được refund toàn bộ
	if (order?.displayFinancialStatus === 'REFUNDED') {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalPackedItems: 0,
			packedProducts: [],
		};
	}

	const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'FULFILLED') || [];

	const packedProducts = fulfillments.flatMap((fulfillment) =>
		(fulfillment.fulfillmentLineItems?.nodes || []).map((item) => {
			const lineItem = item?.lineItem || {};

			return {
				trackingNumber: fulfillment.trackingInfo?.[0]?.number || '',
				package: fulfillment.name || '',
				id: lineItem.id || '',
				fulfilledAt: fulfillment.updatedAt ? new Date(fulfillment.updatedAt).toLocaleDateString('en-GB') : '',
				title: lineItem.title || '',
				currentQuantity: item.quantity || 0,
				quantity: lineItem?.quantity || 0,
				variantTitle: lineItem.variantTitle || '',
				image: lineItem.image?.url || '',
				discountedTotalSet: item.discountedTotalSet,
			};
		}),
	);

	// Group products theo package
	const groupedProducts = packedProducts.reduce((groups, product) => {
		const key = product.package || 'NO_PACKAGE';

		if (!groups[key]) {
			groups[key] = {
				trackingNumber: product.trackingNumber,
				fulfilledAt: product.fulfilledAt,
				products: [],
			};
		}

		groups[key].products.push(product);

		return groups;
	}, {});

	const html = Object.values(groupedProducts)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_PACKED.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}">` : '')
						.replace('__PRODUCT__TITLE__', product.title + (product.currentQuantity ? ` X ${product.currentQuantity}` : ''))
						.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
						.replace(
							'__PRODUCT_PRICE__',
							(() => {
								const lineItem = order?.lineItems?.nodes?.find(
									(item) => item?.id === product?.id,
								);

								const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
								const quantity = Number(product?.quantity) || 0;

								return money?.amount
									? tptFormatMoney({
											amount: Number(money.amount) * quantity,
											currencyCode: money.currencyCode,
										})
									: '';
							})(),
						),
				)
				.join('');

			return PRODUCT_HTML_PACKED_GROUP.replace('__PACKED_TRACKING_NUMBER__', group.trackingNumber || '')
				.replace('__PACKED_DATE__', group.fulfilledAt || '')
				.replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	container.innerHTML = html;

	const totalPackages = packedProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__packed', totalPackages);

	containsPackage('.tpt-order-packed__subheading', window.tptTrackOrder.containsPackage, totalPackages);

	if (packedProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}

	return {
		totalPackedItems: totalPackages,
		packedProducts,
	};
}

/**
 * Render html product homve delivery shipping
 */

function renderHomeDeliveryShipping(order) {
	const container = document.getElementById('tpt-order-tracker__products-shipping--wrapper');

	if (!container) return;

	//const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'OUT_FOR_DELIVERY') || [];
	const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'OUT_FOR_DELIVERY' || item.displayStatus === 'IN_TRANSIT') || [];

	// Danh sách line item đã return hoặc refund
	const excludedLineItemIds = new Set();

	order?.returns?.nodes?.forEach((returnItem) => {
		returnItem?.returnLineItems?.nodes?.forEach((item) => {
			const lineItemId = item?.fulfillmentLineItem?.lineItem?.id;

			if (lineItemId) {
				excludedLineItemIds.add(lineItemId);
			}
		});
	});

	const shippingProducts = fulfillments.flatMap((fulfillment) =>
		(fulfillment.fulfillmentLineItems?.nodes || [])
			.filter((item) => {
				const lineItemId = item?.lineItem?.id;

				return !excludedLineItemIds.has(lineItemId);
			})
			.map((item) => {
				const lineItem = item.lineItem || {};

				return {
					packageName: fulfillment.name || '',
					trackingNumber: fulfillment.trackingInfo?.[0]?.number || '',
					fulfilledAt: fulfillment.updatedAt ? new Date(fulfillment.updatedAt).toLocaleDateString('en-GB') : '',
					id: lineItem.id || '',
					title: lineItem.title || '',
					currentQuantity: lineItem.currentQuantity || '',
					variantTitle: lineItem.variantTitle || '',
					image: lineItem.image?.url || '',
					sku: lineItem.sku || '',
					quantity: item.quantity || 0,
					discountedTotalSet: item.discountedTotalSet,
				};
			}),
	);

	// Group theo packageName + trackingNumber
	const groupedProducts = shippingProducts.reduce((groups, product) => {
		const key = `${product.packageName}__${product.trackingNumber || 'NO_TRACKING'}`;

		if (!groups[key]) {
			groups[key] = {
				packageName: product.packageName,
				trackingNumber: product.trackingNumber,
				fulfilledAt: product.fulfilledAt,
				products: [],
			};
		}

		groups[key].products.push(product);

		return groups;
	}, {});

	container.innerHTML = Object.values(groupedProducts)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_SHIPPING.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}">` : '')
						.replace('__PRODUCT__TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : ''))
						.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
						.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.quantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
				)
				.join('');

			return PRODUCT_HTML_SHIPPING_GROUP.replace('__SHIPPING_TRACKING_NUMBER__', group.trackingNumber || '')
				.replace('__SHIPPING_DATE__', group.fulfilledAt || '')
				.replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	const totalShippingProductsItems = shippingProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__shipping', totalShippingProductsItems);

	containsPackage('.tpt-order-shipping__subheading', window.tptTrackOrder.containsPackage, totalShippingProductsItems);

	if (shippingProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * Render html product home delivery failed
 */

function renderHomeDeliveryFailedDelivery(order) {
	const container = document.getElementById('tpt-order-tracker__products-failed-delivery--wrapper');

	if (!container) return;

	//const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'OUT_FOR_DELIVERY') || [];
	const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'NOT_DELIVERED') || [];

	// Danh sách line item đã return hoặc refund
	const excludedLineItemIds = new Set();

	order?.returns?.nodes?.forEach((returnItem) => {
		returnItem?.returnLineItems?.nodes?.forEach((item) => {
			const lineItemId = item?.fulfillmentLineItem?.lineItem?.id;

			if (lineItemId) {
				excludedLineItemIds.add(lineItemId);
			}
		});
	});

	const failedProducts = fulfillments.flatMap((fulfillment) =>
		(fulfillment.fulfillmentLineItems?.nodes || [])
			.filter((item) => {
				const lineItemId = item?.lineItem?.id;

				return !excludedLineItemIds.has(lineItemId);
			})
			.map((item) => {
				const lineItem = item.lineItem || {};

				return {
					packageName: fulfillment.name || '',
					trackingNumber: fulfillment.trackingInfo?.[0]?.number || '',
					fulfilledAt: fulfillment.updatedAt ? new Date(fulfillment.updatedAt).toLocaleDateString('en-GB') : '',
					id: lineItem.id || '',
					title: lineItem.title || '',
					currentQuantity: lineItem.currentQuantity || '',
					variantTitle: lineItem.variantTitle || '',
					image: lineItem.image?.url || '',
					sku: lineItem.sku || '',
					quantity: item.quantity || 0,
					discountedTotalSet: item.discountedTotalSet,
				};
			}),
	);

	// Group theo packageName + trackingNumber
	const groupedProducts = failedProducts.reduce((groups, product) => {
		const key = `${product.packageName}__${product.trackingNumber || 'NO_TRACKING'}`;

		if (!groups[key]) {
			groups[key] = {
				packageName: product.packageName,
				trackingNumber: product.trackingNumber,
				fulfilledAt: product.fulfilledAt,
				products: [],
			};
		}

		groups[key].products.push(product);

		return groups;
	}, {});

	container.innerHTML = Object.values(groupedProducts)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_HTML.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}">` : '')
						.replace('__PRODUCT__TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : ''))
						.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
						.replace(
							'__PRODUCT_PRICE__',
							(() => {
								const lineItem = order?.lineItems?.nodes?.find(
									(item) => item?.id === product?.id,
								);

								const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
								const quantity = Number(product?.quantity) || 0;

								return money?.amount
									? tptFormatMoney({
											amount: Number(money.amount) * quantity,
											currencyCode: money.currencyCode,
										})
									: '';
							})(),
						),
					)
				.join('');

			return PRODUCT_HTML_FAILED_GROUP.replace('__SHIPPING_TRACKING_NUMBER__', group.trackingNumber || '')
				.replace('__SHIPPING_DATE__', group.fulfilledAt || '')
				.replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	if (!order.paymentGatewayNames?.includes('Cash on Delivery')) {
		console.log('FAILED....');
		if (order.refunds.length || order.tags.includes('refunded_status')) {
			showRefundLabel(container, 'completed');
		} else {
			showRefundLabel(container, 'process');
		}
	}

	const totalFailedProductsItems = failedProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__failed-delivery', totalFailedProductsItems);

	containsPackage('.tpt-order-failed-delivery__subheading', window.tptTrackOrder.containsPackage, totalFailedProductsItems);

	if (failedProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * Render html product homve delivery Confirmed
 * order.lineItems.unfulfilledQuantity > 0
 */
function renderHomeDeliveryConfirmed(order) {
	const container = document.getElementById('tpt-order-tracker__products-confirmed--wrapper');

	if (!container) return null;

	// Không xử lý nếu order có tag partial-canceled

	const hasPartialCanceledTag = order?.tags?.includes('partial-canceled');

	if (hasPartialCanceledTag) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalConfirmedItems: 0,
			confirmedProducts: [],
		};
	}

	const createdAt = order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-GB') : '';

	// Chỉ lấy sản phẩm chưa fulfilled
	const confirmedProducts =
		order?.lineItems?.nodes
			?.filter((item) => item.unfulfilledQuantity > 0)
			?.map((lineItem) => ({
				id: lineItem?.id || '',
				createdAt: createdAt,
				title: lineItem?.title || '',
				variantTitle: lineItem?.variantTitle || '',
				image: lineItem?.image?.url || '',
				sku: lineItem?.sku || '',
				quantity: lineItem?.quantity || 0,
				unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
				discountedTotalSet: lineItem?.discountedTotalSet,
			})) || [];

	container.innerHTML = confirmedProducts
		.map((product) =>
			PRODUCT_HTML_CONFIRMED.replace(
				'__PRODUCT_IMAGE__',
				product.image
					? `<img
						src="${product.image}"
						alt="${product.title}"
					/>`
					: '',
			)
				.replace('__CONFIRMED_DATE__', product.createdAt)
				.replace('__PRODUCT__TITLE__', product.title + (product.unfulfilledQuantity ? ` X ${product.unfulfilledQuantity}` : '') || '')
				.replace('__PRODUCT__VARIANT__', product.variantTitle)
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.unfulfilledQuantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');

	const totalConfirmedProducts = confirmedProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__confirmed', totalConfirmedProducts);
	containsPackage('.tpt-order-confirmed__subheading', window.tptTrackOrder.containsPackage, totalConfirmedProducts);

	if (confirmedProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * Render html product home delivery Confirmed
 * order.lineItems.unfulfilledQuantity > 0
 * tag contains “partial-canceled”
 */

function renderHomeDeliveryPartialCanceled(order) {
	const container = document.getElementById('tpt-order-tracker__products-canceled--wrapper');

	if (!container) return null;

	// Chỉ xử lý khi order có tag partial-canceled
	const hasPartialCanceledTag = order?.tags?.includes('partial-canceled');

	const canceledAt = order.cancelledAt ? new Date(order.cancelledAt).toLocaleDateString('en-GB') : '';

	if (!hasPartialCanceledTag) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalCanceledItems: 0,
			canceledProducts: [],
		};
	}

	// Thêm trường hợp sẩn phẩm remove tức là có currentQuantity == 0 và không thuộc refund và return.

	const returnedLineItemIds = new Set(order?.returns?.nodes?.flatMap((returnItem) => returnItem?.returnLineItems?.nodes?.map((item) => item?.fulfillmentLineItem?.lineItem?.id).filter(Boolean) || []) || []);

	const refundedLineItemIds = new Set(
		order?.returns?.nodes?.flatMap(
			(returnItem) =>
				returnItem?.returnLineItems?.nodes
					?.filter((item) => item?.refundedQuantity > 0)
					?.map((item) => item?.fulfillmentLineItem?.lineItem?.id)
					.filter(Boolean) || [],
		) || [],
	);

	const canceledProducts =
		order?.lineItems?.nodes
			?.filter((item) => {
				const isUnfulfilled = item?.unfulfilledQuantity > 0;
				const isCurrentQuantityZero = item?.currentQuantity === 0;

				const isReturned = returnedLineItemIds.has(item?.id);
				const isRefunded = refundedLineItemIds.has(item?.id);

				return (isUnfulfilled || isCurrentQuantityZero) && !isReturned && !isRefunded;
			})
			?.map((lineItem) => ({
				canceledAt,

				id: lineItem?.id || '',
				title: lineItem?.title || '',
				variantTitle: lineItem?.variantTitle || '',
				image: lineItem?.image?.url || '',
				sku: lineItem?.sku || '',

				quantity: lineItem?.quantity || 0,
				unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
				currentQuantity: lineItem?.currentQuantity || 0,

				discountedTotalSet: lineItem?.discountedTotalSet,
			})) || [];

	console.log('cancel EEE....', canceledProducts);

	const groupedItems = canceledProducts.reduce((groups, item) => {
		const key = item.canceledAt || '-';

		if (!groups[key]) {
			groups[key] = {
				canceledAt: item.canceledAt,
				products: [],
			};
		}

		groups[key].products.push(item);

		return groups;
	}, {});

	container.innerHTML = Object.values(groupedItems)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_DEFAULT.replace(
						'__PRODUCT_IMAGE__',
						product.image
							? `<img
									src="${product.image}"
									alt="${product.title}"
								/>`
							: '',
					)
						.replace('__PRODUCT_TITLE__', product.title + (product.unfulfilledQuantity ? ` X ${product.unfulfilledQuantity}` : ''))
						.replace('__PRODUCT_VARIANT__', product.variantTitle || '')
						.replace(
							'__PRODUCT_PRICE__',
							(() => {
								const lineItem = order?.lineItems?.nodes?.find(
									(item) => item?.id === product?.id,
								);

								const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;

								const quantity =
									Number(product?.unfulfilledQuantity) > 0
										? Number(product.unfulfilledQuantity)
										: Number(product?.quantity) || 0;

								return money?.amount
									? tptFormatMoney({
											amount: Number(money.amount) * quantity,
											currencyCode: money.currencyCode,
										})
									: '';
							})(),
						),
				)
				.join('');

			return PRODUCT_HTML_CANCELED_GROUP.replace('__CANCELED_DATE__', group.canceledAt || '').replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	const hasUncanceledZeroQuantityProduct = order?.lineItems?.nodes?.some((item) => {
		const isCurrentQuantityZero = item?.currentQuantity === 0;
		const isReturned = returnedLineItemIds.has(item?.id);
		const isRefunded = refundedLineItemIds.has(item?.id);

		return isCurrentQuantityZero && !isReturned && !isRefunded;
	});

	console.log('hasUncanceledZeroQuantityProduct', hasUncanceledZeroQuantityProduct);

	if (!order.paymentGatewayNames?.includes('Cash on Delivery')) {
		if (order.refunds?.length || order.tags?.includes('refunded_status')) {
			showRefundLabel(container, 'completed');
		} else {
			showRefundLabel(container, 'process');
		}
	}

	const totalCanceledItems = canceledProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	console.log('Total item ', totalCanceledItems);

	countProductItem('.tpt-order-count__canceled', totalCanceledItems);

	countProductItem('.tpt-order-count__canceled', canceledProducts.length);
	containsPackage('.tpt-order-canceled__subheading', window.tptTrackOrder.containsPackage, canceledProducts.length);

	if (canceledProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

function renderHomeDeliveryCanceled(order) {
	console.log('cancel....');
	const container = document.getElementById('tpt-order-tracker__products-canceled--wrapper');

	if (!container) return;

	const canceledAt = order?.cancelledAt ? new Date(order.cancelledAt).toLocaleDateString('en-GB') : '';
	console.log('cancel....', canceledAt);

	// Chỉ lấy sản phẩm chưa fulfilled
	const canceledProducts =
		order?.lineItems?.nodes?.map((lineItem) => ({
			canceledAt,

			id: lineItem?.id || '',
			title: lineItem?.title || '',
			variantTitle: lineItem?.variantTitle || '',
			image: lineItem?.image?.url || '',
			sku: lineItem?.sku || '',
			quantity: lineItem?.quantity || 0,
			unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
			discountedTotalSet: lineItem?.discountedTotalSet,
		})) || [];

	console.log('renderHomeDeliveryCanceled', canceledProducts);

	// Group theo Cancel Date
	const groupedItems = canceledProducts.reduce((groups, item) => {
		const key = item.canceledAt || '-';

		if (!groups[key]) {
			groups[key] = {
				canceledAt: item.canceledAt,
				products: [],
			};
		}

		groups[key].products.push(item);

		return groups;
	}, {});

	var quantity = 0;

	container.innerHTML = Object.values(groupedItems)
	.map((group) => {
		const productsHtml = group.products
			.map((product) => {
				quantity =
					Number(product?.unfulfilledQuantity) > 0
						? Number(product.unfulfilledQuantity)
						: Number(product?.quantity) || 0;

				return PRODUCT_ITEM_HTML_DEFAULT.replace(
					'__PRODUCT_IMAGE__',
					product.image
						? `<img src="${product.image}" alt="${product.title}" />`
						: '',
				)
					.replace(
						'__PRODUCT_TITLE__',
						product.title + (quantity ? ` X ${quantity}` : ''),
					)
					.replace('__PRODUCT_VARIANT__', product.variantTitle || '')
					.replace(
						'__PRODUCT_PRICE__',
						(() => {
							const lineItem = order?.lineItems?.nodes?.find(
								(item) => item?.id === product?.id,
							);

							const money =
								lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;

							return money?.amount
								? tptFormatMoney({
										amount: Number(money.amount) * quantity,
										currencyCode: money.currencyCode,
									})
								: '';
						})(),
					);
			})
			.join('');

		return PRODUCT_HTML_CANCELED_GROUP
			.replace('__CANCELED_DATE__', group.canceledAt || '')
			.replace('__PRODUCTS__', productsHtml);
	})
	.join('');

	if (!order.paymentGatewayNames?.includes('Cash on Delivery')) {
		if (order.refunds.length || order.tags.includes('refunded_status')) {
			showRefundLabel(container, 'completed');
		} else {
			showRefundLabel(container, 'process');
		}
	}

	//const totalCanceledItems = canceledProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	const totalCanceledItems = quantity

	console.log('Total item ', totalCanceledItems);

	countProductItem('.tpt-order-count__canceled', totalCanceledItems);

	containsPackage('.tpt-order-canceled__subheading', window.tptTrackOrder.containsPackage, totalCanceledItems);

	if (canceledProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * “FinancialStatus” == voided
 */
function renderHomeDeliveryVoidedCanceled(order) {
	const container = document.getElementById('tpt-order-tracker__products-canceled--wrapper');

	if (!container) return null;

	const canceledAt = order.cancelledAt ? new Date(order.cancelledAt).toLocaleDateString('en-GB') : '';
	// Chỉ lấy sản phẩm chưa fulfilled
	const canceledProducts =
		order?.lineItems?.nodes?.map((lineItem) => ({
			id: lineItem?.id || '',
			canceledAt: canceledAt,
			title: lineItem?.title || '',
			variantTitle: lineItem?.variantTitle || '',
			image: lineItem?.image?.url || '',
			sku: lineItem?.sku || '',
			quantity: lineItem?.quantity || 0,
			unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
			discountedTotalSet: lineItem?.discountedTotalSet,
		})) || [];

	// Group theo Cancel Date
	const groupedItems = canceledProducts.reduce((groups, item) => {
		const key = item.canceledAt || '-';

		if (!groups[key]) {
			groups[key] = {
				canceledAt: item.canceledAt,
				products: [],
			};
		}

		groups[key].products.push(item);

		return groups;
	}, {});

	container.innerHTML = Object.values(groupedItems)
		.map((group) => {
			const productsHtml = group.products
				.map((product) =>
					PRODUCT_ITEM_HTML_DEFAULT.replace(
						'__PRODUCT_IMAGE__',
						product.image
							? `<img
									src="${product.image}"
									alt="${product.title}"
								/>`
							: '',
					)
						.replace('__PRODUCT_TITLE__', product.title + (product.unfulfilledQuantity ? ` X ${product.unfulfilledQuantity}` : ''))
						.replace('__PRODUCT_VARIANT__', product.variantTitle || '')
						.replace(
							'__PRODUCT_PRICE__',
							(() => {
								const lineItem = order?.lineItems?.nodes?.find(
									(item) => item?.id === product?.id,
								);

								const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
								const quantity = Number(product?.unfulfilledQuantity) || 0;

								return money?.amount
									? tptFormatMoney({
											amount: Number(money.amount) * quantity,
											currencyCode: money.currencyCode,
										})
									: '';
							})(),
						),
				)
				.join('');

			return PRODUCT_HTML_VOIDED_CANCELED_GROUP.replace('__CANCELED_DATE__', group.canceledAt || '').replace('__PRODUCTS__', productsHtml);
		})
		.join('');

	if (!order.paymentGatewayNames?.includes('Cash on Delivery')) {
		if (order.refunds.length || order.tags.includes('refunded_status')) {
			showRefundLabel(container, 'completed');
		} else {
			showRefundLabel(container, 'process');
		}
	}

	const totalCanceledItems = canceledProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__canceled', totalCanceledItems);
	containsPackage('.tpt-order-canceled__subheading', window.tptTrackOrder.containsPackage, totalCanceledItems);
}

/**
 * Store pickup Confirmed
 */

function renderPickupConfirmed(order) {
	const container = document.getElementById('tpt-order-tracker__products-confirmed--wrapper');

	if (!container) return null;

	// Không xử lý nếu:
	// - Có tag partial-canceled
	// - fulfillmentOrders có status IN_PROGRESS hoặc CLOSED
	const hasPartialCanceledTag = order?.tags?.includes('partial-canceled');

	const hasBlockedFulfillmentStatus = order?.fulfillmentOrders?.nodes?.some((item) => item.status === 'IN_PROGRESS' || item.status === 'CLOSED');

	if (hasPartialCanceledTag || hasBlockedFulfillmentStatus) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalConfirmedItems: 0,
			confirmedProducts: [],
		};
	}

	const createdAt = order?.createdAt ? new Date(order.createdAt).toLocaleDateString('en-GB') : '';

	// Chỉ lấy sản phẩm chưa fulfilled
	const confirmedProducts =
		order?.lineItems?.nodes
			?.filter((item) => item.unfulfilledQuantity > 0)
			?.map((lineItem) => ({
				id: lineItem?.id || '',
				createdAt,
				title: lineItem?.title || '',
				variantTitle: lineItem?.variantTitle || '',
				image: lineItem?.image?.url || '',
				sku: lineItem?.sku || '',
				quantity: lineItem?.quantity || 0,
				unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
				discountedTotalSet: lineItem?.discountedTotalSet,
			})) || [];

	container.innerHTML = confirmedProducts
		.map((product) =>
			PRODUCT_HTML_PICKUP_CONFIRMED.replace(
				'__PRODUCT_IMAGE__',
				product.image
					? `<img
						src="${product.image}"
						alt="${product.title}"
					/>`
					: '',
			)
				.replace('__CONFIRMED_DATE__', product.createdAt)
				.replace('__PRODUCT__TITLE__', product.title + (product.unfulfilledQuantity ? ` X ${product.unfulfilledQuantity}` : '') || '')
				.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
				.replace(
					'__PRODUCT_PRICE__',
					(() => {
						const lineItem = order?.lineItems?.nodes?.find(
							(item) => item?.id === product?.id,
						);

						const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
						const quantity = Number(product?.unfulfilledQuantity) || 0;

						return money?.amount
							? tptFormatMoney({
									amount: Number(money.amount) * quantity,
									currencyCode: money.currencyCode,
								})
							: '';
					})(),
				),
		)
		.join('');

	const totalConfirmedProducts = confirmedProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__confirmed', totalConfirmedProducts);
	containsPackage('.tpt-order-confirmed__subheading', window.tptTrackOrder.containsPackage, totalConfirmedProducts);

	if (confirmedProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

function renderPickupReadyToCollect(order) {
	const container = document.getElementById('tpt-order-tracker__products-ready_to_collect--wrapper');

	if (!container) return null;

	const pickupStoreName = order?.shippingLine?.title || '';

	const fulfillmentOrders = order?.fulfillmentOrders?.nodes || [];

	const inProgressFulfillmentOrders = fulfillmentOrders.filter((item) => item.status === 'IN_PROGRESS');

	if (inProgressFulfillmentOrders.length === 0) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalCollectedItems: 0,
			collectedProducts: [],
		};
	}

	// Lấy SKU thuộc các fulfillment order IN_PROGRESS
	const inProgressSkus = new Set(inProgressFulfillmentOrders.flatMap((fo) => fo?.lineItems?.nodes?.map((item) => item.sku) || []));

	// Map với lineItems
	const collectedProducts =
		order?.lineItems?.nodes
			?.filter((lineItem) => inProgressSkus.has(lineItem.sku))
			?.map((lineItem) => ({
				id: lineItem?.id || '',
				title: lineItem?.title || '',
				variantTitle: lineItem?.variantTitle || '',
				image: lineItem?.image?.url || '',
				sku: lineItem?.sku || '',
				quantity: lineItem?.quantity || 0,
				trackingNumber: '-',
				pickupStoreName,
				collectedAt: order?.createdAt ? new Date(order.createdAt).toLocaleDateString('en-GB') : '',
				discountedTotalSet: lineItem?.discountedTotalSet,
			})) || [];

	const productsHtml = collectedProducts
		.map((product) =>
			PRODUCT_ITEM_HTML_READY_TO_COLLECT.replace(
				'__PRODUCT_IMAGE__',
				product.image
					? `<img
						src="${product.image}"
						alt="${product.title}"
					/>`
					: '',
			)
				.replace('__PRODUCT_TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : ''))
				.replace('__PRODUCT_VARIANT__', product.variantTitle || '')
				.replace('__PRODUCT_PRICE__', product.discountedTotalSet?.presentmentMoney ? tptFormatMoney(product.discountedTotalSet.presentmentMoney) : ''),
		)
		.join('');

	container.innerHTML = PRODUCT_HTML_READY_TO_COLLECTED_GROUP.replace('__COLLECTED_DATE__', collectedProducts[0]?.collectedAt || '')
		.replace('__COLLECTED_TRACKING_NUMBER__', pickupStoreName)
		.replace('__PRODUCTS__', productsHtml);

	const totalCollectedProducts = collectedProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__ready_to_collect', totalCollectedProducts);

	containsPackage('.tpt-order-ready_to_collect__subheading', window.tptTrackOrder.containsPackage, totalCollectedProducts);

	if (collectedProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}

	return {
		totalCollectedItems: collectedProducts.length,
		collectedProducts,
	};
}

function renderPickupCollected(order) {
	const container = document.getElementById('tpt-order-tracker__products-collected--wrapper');

	if (!container) return null;

	// Lấy Fulfillment Order có status CLOSED
	const closedFulfillmentOrder = order?.fulfillmentOrders?.nodes?.find((item) => item.status === 'CLOSED');

	if (!closedFulfillmentOrder) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalCollectedItems: 0,
			collectedProducts: [],
		};
	}

	// Lấy location name
	const pickupStoreName = closedFulfillmentOrder?.assignedLocation?.location?.name || closedFulfillmentOrder?.assignedLocation?.name || order?.shippingLine?.title || '-';

	// Lấy ID các sản phẩm đã return
	const returnedLineItemIds = new Set(order?.returns?.nodes?.flatMap((returnItem) => returnItem?.returnLineItems?.nodes?.map((item) => item?.fulfillmentLineItem?.lineItem?.id).filter(Boolean) || []) || []);

	// Chỉ xem là refund khi có transaction SUCCESS
	const hasSuccessfulRefund = order?.refunds?.some((refund) => refund?.transactions?.nodes?.some((transaction) => transaction?.status === 'SUCCESS')) || false;

	// Lấy các fulfillment đã fulfilled
	const fulfillments = order?.fulfillments?.filter((item) => item.displayStatus === 'FULFILLED') || [];

	const collectedProducts = fulfillments.flatMap((fulfillment) => {
		const collectedAt = fulfillment?.updatedAt ? new Date(fulfillment.updatedAt).toLocaleDateString('en-GB') : '';

		return (
			fulfillment?.fulfillmentLineItems?.nodes
				?.filter((item) => {
					const lineItemId = item?.lineItem?.id;

					// Không hiển thị sản phẩm đã return
					return !returnedLineItemIds.has(lineItemId);
				})
				?.map((item) => {
					const lineItem = item?.lineItem || {};

					return {
						id: lineItem?.id || '',
						trackingNumber: pickupStoreName,
						title: lineItem?.title || '',
						variantTitle: lineItem?.variantTitle || '',
						image: lineItem?.image?.url || '',
						sku: lineItem?.sku || '',
						quantity: item?.quantity || 0,
						collectedAt,
						discountedTotalSet: item?.discountedTotalSet || lineItem?.discountedTotalSet,
					};
				}) || []
		);
	});

	// Nếu toàn bộ sản phẩm đều đã return
	if (collectedProducts.length === 0) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalCollectedItems: 0,
			collectedProducts: [],
		};
	}

	container.innerHTML = collectedProducts
		.map((product) =>
			PRODUCT_HTML_COLLECTED.replace('__COLLECTED_DATE__', product.collectedAt)
				.replace('__COLLECTED_TRACKING_NUMBER__', product.trackingNumber)
				.replace(
					'__PRODUCT_IMAGE__',
					product.image
						? `<img
							src="${product.image}"
							alt="${product.title}"
						/>`
						: '',
				)
				.replace('__PRODUCT__TITLE__', product.title + (product.quantity ? ` X ${product.quantity}` : ''))
				.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.quantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');

	const totalCollectedProducts = collectedProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__collected', totalCollectedProducts);

	containsPackage('.tpt-order-collected__subheading', window.tptTrackOrder.containsPackage, totalCollectedProducts);

	return {
		totalCollectedItems: totalCollectedProducts,
		collectedProducts,
	};
}

/**
 * Render html product pickup return
 * transaction != SUCCESS
 */

function renderPickupReturns(order) {
	const container = document.getElementById('tpt-order-tracker__products-returned--wrapper');

	if (!container) return null;

	const returnedItems = order.returns.nodes.flatMap((returnItem) => {
		const refundStatus = returnItem.refunds?.nodes?.[0]?.transactions?.nodes?.[0]?.status || '';

		// Skip nếu refund transaction không SUCCESS
		if (refundStatus === 'SUCCESS') return [];

		return (
			returnItem.returnLineItems?.nodes?.map((item) => {
				const lineItem = item.fulfillmentLineItem?.lineItem;

				return {
					returnName: returnItem.name,
					returnStatus: returnItem.status,
					returnedAt: returnItem.refunds?.nodes?.[0]?.updatedAt ? new Date(returnItem.refunds.nodes[0].updatedAt).toLocaleDateString('en-GB') : '',
					refundStatus,
					id: lineItem?.id || '',
					title: lineItem?.title || '',
					variantTitle: lineItem?.variantTitle || '',
					image: lineItem?.image?.url || '',
					sku: lineItem?.sku || '',
					discountedTotalSet: lineItem?.discountedTotalSet,
					quantity: item?.quantity || 0,
					refundedQuantity: item?.refundedQuantity || 0,
					returnReason: item?.returnReasonNote || '',
				};
			}) || []
		);
	});

	//container.innerHTML = renderProduct(returnedItems);

	container.innerHTML = returnedItems
		.map((product) =>
			PRODUCT_HTML_RETURNED.replace('__COLLECTED_DATE__', product.collectedAt)
				.replace('__COLLECTED_TRACKING_NUMBER__', product.trackingNumber)
				.replace(
					'__PRODUCT_IMAGE__',
					product.image
						? `<img
							src="${product.image}"
							alt="${product.title}"
						/>`
						: '',
				)
				.replace('__RETURNED_DATE__', product.returnedAt)
				.replace('__PRODUCT__TITLE__', product.title + (product.refundedQuantity ? ` X ${product.refundedQuantity}` : '') || '')
				.replace('__PRODUCT__VARIANT__', product.variantTitle)
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.refundedQuantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');

	const totalReturnedItems = returnedItems.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__return', totalReturnedItems);
	containsPackage('.tpt-order-returned__subheading', window.tptTrackOrder.containsPackage, totalReturnedItems);

	if (returnedItems.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * Render html product pickup Refunded
 * transaction == SUCCESS
 */

function renderPickupRefunded(order) {
	const container = document.getElementById('tpt-order-tracker__products-refunded--wrapper');

	if (!container) return null;

	const refundedItems = order.returns.nodes.flatMap((refundedItem) => {
		const refundStatus = refundedItem.refunds?.nodes?.[0]?.transactions?.nodes?.[0]?.status || '';

		// Skip nếu refund transaction không SUCCESS
		if (refundStatus !== 'SUCCESS') return [];

		return (
			refundedItem.returnLineItems?.nodes?.map((item) => {
				const lineItem = item.fulfillmentLineItem?.lineItem;

				return {
					returnName: refundedItem.name,
					returnStatus: refundedItem.status,
					refundedAt: refundedItem.refunds?.nodes?.[0]?.updatedAt ? new Date(refundedItem.refunds.nodes[0].updatedAt).toLocaleDateString('en-GB') : '',
					refundStatus,
					id: lineItem?.id || '',
					title: lineItem?.title || '',
					variantTitle: lineItem?.variantTitle || '',
					image: lineItem?.image?.url || '',
					sku: lineItem?.sku || '',
					discountedTotalSet: lineItem?.discountedTotalSet,
					quantity: item?.quantity || 0,
					refundedQuantity: item?.refundedQuantity || 0,
					returnReason: item?.returnReasonNote || '',
				};
			}) || []
		);
	});

	//container.innerHTML = renderProduct(refundedItems);

	container.innerHTML = refundedItems
		.map((product) =>
			PRODUCT_HTML_REFUNDED.replace(
				'__PRODUCT_IMAGE__',
				product.image
					? `<img
						src="${product.image}"
						alt="${product.title}"
					/>`
					: '',
			)
				.replace('__REFUNDED_DATE__', product.refundedAt)
				.replace('__PRODUCT__TITLE__', product.title + (product.refundedQuantity ? ` X ${product.refundedQuantity}` : '') || '')
				.replace('__PRODUCT__VARIANT__', product.variantTitle)
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.refundedQuantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');

	const totalRefundedItems = refundedItems.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__refund', totalRefundedItems);
	containsPackage('.tpt-order-refunded__subheading', window.tptTrackOrder.containsPackage, totalRefundedItems);

	if (refundedItems.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}

/**
 * Main pickup  partial canceled
 */

function renderPickupPartialCanceled(order) {
	const container = document.getElementById('tpt-order-tracker__products-canceled--wrapper');

	if (!container) return null;

	const hasPartialCanceledTag = order?.tags?.includes('partial-canceled');

	if (!hasPartialCanceledTag) {
		container.innerHTML = '';

		collapsedBox(container.closest('.tpt-order-tracker__box-status'));

		return {
			totalCanceledItems: 0,
			canceledProducts: [],
		};
	}

	const canceledAt = order?.cancelledAt ? new Date(order.cancelledAt).toLocaleDateString('en-GB') : '-';

	// Lấy toàn bộ SKU thuộc fulfillment order có status OPEN
	const openFulfillmentSkus = order?.fulfillmentOrders?.nodes?.filter((fulfillmentOrder) => fulfillmentOrder.status === 'OPEN')?.flatMap((fulfillmentOrder) => fulfillmentOrder?.lineItems?.nodes?.map((item) => item.sku) || []) || [];

	// Map SKU sang lineItems để lấy đầy đủ thông tin sản phẩm
	const canceledProducts =
		order?.lineItems?.nodes
			?.filter((lineItem) => openFulfillmentSkus.includes(lineItem.sku))
			?.map((lineItem) => ({
				id: lineItem?.id || '',
				canceledAt,
				title: lineItem?.title || '',
				variantTitle: lineItem?.variantTitle || '',
				image: lineItem?.image?.url || '',
				sku: lineItem?.sku || '',
				quantity: lineItem?.quantity || 0,
				unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
				discountedTotalSet: lineItem?.discountedTotalSet,
			})) || [];

	container.innerHTML = canceledProducts
		.map((product) =>
			PRODUCT_HTML_CANCELED.replace('__PRODUCT_IMAGE__', product.image ? `<img src="${product.image}" alt="${product.title}" />` : '')
				.replace('__CANCELED_DATE__', product.canceledAt)
				.replace('__PRODUCT__TITLE__', product.title + (product.unfulfilledQuantity ? ` X ${product.unfulfilledQuantity}` : ''))
				.replace('__PRODUCT__VARIANT__', product.variantTitle || '')
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.unfulfilledQuantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');

	const totalcanceledProducts = canceledProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__canceled', totalcanceledProducts);
	containsPackage('.tpt-order-canceled__subheading', window.tptTrackOrder.containsPackage, totalcanceledProducts);

	if (canceledProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}

	return {
		totalCanceledItems: canceledProducts.length,
		canceledProducts,
	};
}

/**
 * Main pickup canceled
 */
function renderPickupCanceled(order) {
	const container = document.getElementById('tpt-order-tracker__products-canceled--wrapper');

	if (!container) return null;

	const canceledAt = order.cancelledAt ? new Date(order.cancelledAt).toLocaleDateString('en-GB') : '';
	// Chỉ lấy sản phẩm chưa fulfilled
	const canceledProducts =
		order?.lineItems?.nodes
			?.filter((item) => item.unfulfilledQuantity > 0)
			?.map((lineItem) => ({
				id: lineItem?.id || '',
				canceledAt: canceledAt,
				title: lineItem?.title || '',
				variantTitle: lineItem?.variantTitle || '',
				image: lineItem?.image?.url || '',
				sku: lineItem?.sku || '',
				quantity: lineItem?.quantity || 0,
				unfulfilledQuantity: lineItem?.unfulfilledQuantity || 0,
				discountedTotalSet: lineItem?.discountedTotalSet,
			})) || [];

	container.innerHTML = canceledProducts
		.map((product) =>
			PRODUCT_HTML_CANCELED.replace(
				'__PRODUCT_IMAGE__',
				product.image
					? `<img
						src="${product.image}"
						alt="${product.title}"
					/>`
					: '',
			)
				.replace('__CANCELED_DATE__', product.canceledAt)
				.replace('__PRODUCT__TITLE__', product.title + (product.unfulfilledQuantity ? ` X ${product.unfulfilledQuantity}` : '') || '')
				.replace('__PRODUCT__VARIANT__', product.variantTitle)
				.replace(
	'__PRODUCT_PRICE__',
	(() => {
		const lineItem = order?.lineItems?.nodes?.find(
			(item) => item?.id === product?.id,
		);

		const money = lineItem?.discountedUnitPriceAfterAllDiscountsSet?.shopMoney;
		const quantity = Number(product?.unfulfilledQuantity) || 0;

		return money?.amount
			? tptFormatMoney({
					amount: Number(money.amount) * quantity,
					currencyCode: money.currencyCode,
				})
			: '';
	})(),
),
		)
		.join('');

	const totalCanceledProducts = canceledProducts.reduce((total, item) => total + (Number(item.quantity) || 0), 0);

	countProductItem('.tpt-order-count__canceled', totalCanceledProducts);
	containsPackage('.tpt-order-canceled__subheading', window.tptTrackOrder.containsPackage, totalCanceledProducts);

	if (canceledProducts.length === 0) {
		collapsedBox(container.closest('.tpt-order-tracker__box-status'));
	}
}
